import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-policy-creator',
  templateUrl: './policy-creator.component.html',
  styleUrls: ['./policy-creator.component.css']
})
export class PolicyCreatorComponent {
  readonly policyTypes = [
    {
      id: 'vm' as const,
      title: 'VM Policy',
      subtitle: 'Virtual Machine resource lifecycle',
      icon: 'computer',
      description: 'Define how virtual machine resources are created, cleaned up daily, and handled at class end.',
      color: '#1565C0'
    },
    {
      id: 'user-account' as const,
      title: 'User Account Policy',
      subtitle: 'Azure subscription lifecycle',
      icon: 'manage_accounts',
      description: 'Define creation mode, subscription cleanup, and quota limits with budget notifications.',
      color: '#2E7D32'
    }
  ];

  constructor(private readonly router: Router) {}

  selectType(type: 'vm' | 'user-account'): void {
    this.router.navigate(['/policy-template/create', type]);
  }
}
